import styled from 'styled-components';
import { ShadowBoxDark } from 'app/components';
import { textTransform } from 'utils';

export const ButtonZoom = styled.button.attrs({
  className: 'btn-zoom'
})`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  background-color: #666;
  position: relative;
  transition: opacity 0.2s ease-out;
  opacity: 0.8;

  .svg-zoom-in,
  .svg-zoom-out {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    fill: #fff;
  }

  &:hover {
    opacity: 1;
  }
`;

export const BlockSeatPlanInner = styled(ShadowBoxDark).attrs({
  className: 'b-seatplan__inner'
})`
  .b-seatplan__btn-zoom-wrapper {
    padding: ${({ theme }) => `14px ${theme.indent.l} ${theme.indent.l}`};
    font-size: 0;
    text-align: right;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    .b-seatplan__btn-zoom-wrapper {
      padding: ${({ theme }) => `0 ${theme.indent.m} 10px`};
    }
  }
`;

export const SeatPlanHall = styled.div.attrs({
  className: 'b-seatplan__hall'
})`
  padding: ${({ theme }) => `${theme.indent.l} ${theme.indent.l} 10px`};
  text-align: center;
  overflow-x: auto;

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    padding: ${({ theme }) => `${theme.indent.l} ${theme.indent.m} 10px`};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    padding: ${({ theme }) => `${theme.indent.s} ${theme.indent.m} 10px`};
  }
`;

export const SeatPlanHallInner = styled.div.attrs({
  className: 'b-seatplan__hall-inner'
})`
  display: inline-block;
`;

export const LegendWrapper = styled.div`
  padding: ${({ theme }) => theme.indent.s};
  overflow-x: auto;
  overflow-y: hidden;
  text-align: center;
  border-top: 1px solid ${({ theme }) => theme.color.borderDark};
`;

export const LegendList = styled.ul.attrs({
  className: 'l-legend'
})`
  display: inline-flex;
  margin: 0 -${({ theme }) => theme.indent.s};

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const LegendListItem = styled.li`
  width: 96px;
  padding: 0 ${({ theme }) => theme.indent.s};

  .l-legend__inner {
    width: 100%;

    & > .svg-more {
      width: 24px;
      height: 24px;
      fill: ${({ theme }) => theme.color.rgbaWhite('.8')};
    }
  }

  .l-legend__icon {
    max-width: 48px;
  }

  .l-legend__text {
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.17;
    text-align: center;
    text-transform: ${textTransform};
    color: ${({ theme }) => theme.color.labelColor};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    display: flex;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.xs.width}) {
    min-width: 76px;
  }
`;

export const ScreenLine = styled.div`
  width: ${({ width }) => width}px;
  margin: 0 auto;
  position: relative;

  & > .svg-screen {
    width: ${({ width }) => Math.round(width + width / 11.1)}px;
    height: ${({ width }) => Math.round((width + width / 11.1) * 0.1159)}px;
    margin-left: -${({ width }) => Math.round(width / 22.2)}px;
  }

  & > p {
    font-size: ${({ width }) => width / 386.6}rem;
    font-weight: 500;
    letter-spacing: 1px;
    text-align: center;
    color: ${({ theme }) => theme.color.rgbaWhite('.9')};
    text-transform: ${textTransform};
    position: absolute;
    width: 100%;
    top: ${({ width }) => width / 22.5}px;
  }
`;

export const ListRows = styled.ul.attrs({
  className: 'l-rows'
})`
  display: inline-block;
  width: ${({ width }) => width}px;
`;

export const ListRowsItem = styled.li.attrs(({ rowName }) => ({
  className: 'l-rows__item',
  'data-name': `${rowName}`
}))`
  display: block;
  margin-top: ${({ isExtraMarginNeeded, isFirstRow, gap }) => {
    if (isExtraMarginNeeded) {
      return `${gap * 8}px`;
    }

    return isFirstRow ? '0' : `${gap * 4}px`;
  }};
  margin-left: ${({ fontSize }) => fontSize * 3}px;
  position: relative;

  &::before {
    content: attr(data-name);
    font-size: ${({ fontSize }) => Math.round(fontSize) <= 12 ? 12 : fontSize}px;
    line-height: 1.1;
    position: absolute;
    left: -${({ fontSize }) => Math.abs(fontSize) * 3 === 0 ? 10 : Math.abs(fontSize) * 3}px;
    transition: color .1s ease-out;
    pointer-events: none;
  }

  &:hover {
    &::before {
      color: ${({ theme }) => theme.color.accent}
    }
  }
  @media only screen and (max-width: 600px){
    margin-top: ${({ isExtraMarginNeeded, isFirstRow, gap }) => {
    if (isExtraMarginNeeded) {
      return `${gap * 8}px`;
    }

    return isFirstRow ? '0' : `${gap * 2}px`;
  }};

  }
`;

export const ListSeats = styled.ul.attrs({
  className: 'l-seats'
})`
  margin: 0 ${({ gap }) => `${gap / -2}px`};
  font-size: 0;

  @media only screen and (max-width: 600px){
    margin: 0px;
    margin-left:5px;
  }
`;

export const ListSeatsItem = styled.li.attrs({
  className: 'l-seats__item'
})`

width: ${({ width, oneSeatLength }) =>
    width ? (`${oneSeatLength * width}% `) : `${oneSeatLength}% `};
padding: 0 ${({ gap, width }) => (width === 2 ? gap / 1.33333 : gap / 2)} px;
position: relative;
cursor: pointer;

  & > div {
    &::before {
    content: '';
    position: absolute;
    width: calc(100 % - ${({ gap, width }) => (width === 2 ? gap + gap / 2 : gap)}px);
  height: 100 %;
  border: 2px solid ${({ theme }) => theme.color.accentDark};
  border - radius: ${({ width }) =>
    width === 2 ? '2px 2px 14% 14% / 2px 2px 30% 30%' : '2px 2px 25% 25%'
  };
  transition: opacity .15s ease - out;
  opacity: 0;
}
  }

  & [tabindex = "-1"] {
  pointer - events: none;
}

  &._disabled {
    pointer-events: none
  cursor: none;

  }
  &._disablewheelchair {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &._selected {
  animation: scaleAndBounce 0.3s ease -in both;

    & > div::before {
    display: none;
  }
}

  &:focus {
    & > div {
      &::before {
      opacity: 1;
    }
  }
}

@media only screen and(max - width: 600px){
  padding: 0px;
}

@media screen and(min - width: ${({ theme }) => theme.breakPoints.md.width}) {
    &:hover {
      & > div {
        &::before {
        opacity: 1;
      }
    }
  }
}

@media screen and(max - width: ${({ theme }) => theme.breakPoints.md.width}) {
    &:active {
      & > div {
        &::before {
        opacity: 1;
      }
    }
  }
}
`;

export const SeatsItemImg = styled.img`
vertical - align: middle;
width: 100 %;
max - width: none;
`;

export const SeatsDetailsItem = styled.li.attrs({
  className: 'l-seats-details__item'
})`
width: 100%;

  & + & {
  margin- top: ${({ theme }) => theme.indent.m};
  }

  .l - seats - details__title {
  margin - top: 6px;
  font - size: 1.4rem;
  font - weight: 500;
  letter - spacing: 0.9px;
  text - transform: uppercase;
  color: ${({ categoryColor }) => categoryColor};
}
.l-seats-details__icon{
  display: flex;
  align-items: center;
}
  .l - seats - details - description {
  font - size: 1.6rem;
  line - height: 1.13;
}

  .l - legend__icon {
  vertical - align: middle;
  max - width: 48px;
}

`;

export const SeatsDetailsName = styled.span.attrs({
  className: 'l-seats-details__name'
})`
vertical - align: middle;
margin - left: ${({ theme }) => theme.indent.s};
font - size: 1.8rem;
color: ${({ categoryColor }) => categoryColor};
`;
